import { React, useState, useEffect, createContext } from "react";
import { useQuery, useQueryClient } from "react-query";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import styles from "../assets/css/modules/shipmentReport.module.css";
import axiosInstance from "../helpers/AxiosInstance";
import { Box } from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  Header,
  Title,
  ShipmentsReportsTable,
  ButtonsContainer,
  LoadingButton,
} from "../components/utilities";
import NewPrintBtn from "../components/utilities/NewPrintBtn";
const Button = styled.button`
  position: relative;
  border: 0px solid var(--primary-color);
  border-color: var(--primary-color);
  transition: border 0.5s;
  &:hover {
    border: 2px solid var(--primary-color);
  }
  cursor: pointer;
  min-width: 142px;
  height: 50px;
  background: ${(props) => (props.primary ? "var(--gradient)" : "transparent")};
  box-shadow: ${(props) => (props.primary ? "0px 3px 6px #0000005e" : "none")};
  border-radius: 5px;
  border: 0;
  opacity: 1;
  text-align: center;
  font: normal normal 900 15px Cairo;
  letter-spacing: 0px;
  color: ${(props) => (props.primary ? "white" : "black")};
  opacity: 1;
  @media (max-width: 1440px) {
    font-size: 12px;
  }
`;
const StopButton = styled.button`
  position: relative;
  border: 0px solid var(--primary-color);
  border-color: var(--primary-color);
  transition: border 0.5s;
  &:hover {
    scale: 0.96;
  }
  cursor: pointer;
  width: 180px;
  height: 40px;
  background: red;
  box-shadow: 0px 3px 6px #0000005e;
  border-radius: 5px;
  border: 0;
  opacity: 1;
  text-align: center;
  font: normal normal 900 16px Cairo;
  letter-spacing: 0px;
  color: white;
  opacity: 1;
  @media (max-width: 1440px) {
    font-size: 16px;
  }
`;

const FilterContainer = styled.div`
  background: #ffffff;
  border-radius: 12px;
  padding: 24px;
  margin-top: 20px;
  margin-bottom: 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  border: 1px solid #f1f5f9;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const FilterGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

const FilterField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const FilterLabel = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: #475569;
`;

const FilterInput = styled.input`
  padding: 10px 14px;
  border: 1.5px solid #e2e8f0;
  border-radius: 8px;
  font-size: 14px;
  color: #1e293b;
  outline: none;
  background-color: #f8fafc;
  transition: all 0.2s ease;
  &:focus {
    border-color: var(--primary-color);
    background-color: #ffffff;
    box-shadow: 0 0 0 3px rgba(67, 95, 134, 0.15);
  }
`;

const FilterSelect = styled.select`
  padding: 10px 14px;
  border: 1.5px solid #e2e8f0;
  border-radius: 8px;
  font-size: 14px;
  color: #1e293b;
  outline: none;
  background-color: #f8fafc;
  transition: all 0.2s ease;
  cursor: pointer;
  &:focus {
    border-color: var(--primary-color);
    background-color: #ffffff;
    box-shadow: 0 0 0 3px rgba(67, 95, 134, 0.15);
  }
`;

export const selectedContext = createContext();
export default function ShipmentsReport() {
  const queryClient = useQueryClient();
  const [selected, setSelected] = useState([]);
  const navigate = useNavigate();
  const [refetchKey, setRefetchKey] = useState(1);
  const [fetchingData, setFetchingData] = useState(true);

  const [mergedData, setMergedData] = useState([]);
  const [queryState, setQueryState] = useState({
    allShipments: true,
    delivered: false,
    returned: false,
    processing: false,
    paid: false,
    expected: false,
  });

  const [filterSerial, setFilterSerial] = useState("");
  const [filterName, setFilterName] = useState("");
  const [filterPhone, setFilterPhone] = useState("");
  const [filterStatus, setFilterStatus] = useState("All");
  const [filterCity, setFilterCity] = useState("All");
  const [filterFromDate, setFilterFromDate] = useState("");
  const [filterToDate, setFilterToDate] = useState("");
  const [globalSearch, setGlobalSearch] = useState("");

  const { t, i18n } = useTranslation("reports");
  const isAr = i18n.language === "ar";

  const uniqueStatuses = ["All", ...new Set(mergedData.map((r) => r.StatusNameA).filter(Boolean))];
  const uniqueCities = ["All", ...new Set(mergedData.map((r) => r.ToCityName).filter(Boolean))];

  const filteredData = mergedData.filter((row) => {
    if (filterSerial && !String(row.AWB || "").toLowerCase().includes(filterSerial.toLowerCase())) {
      return false;
    }
    if (filterName && !String(row.ToConsigneeName || "").toLowerCase().includes(filterName.toLowerCase())) {
      return false;
    }
    if (filterPhone && !String(row.ToPhone || "").toLowerCase().includes(filterPhone.toLowerCase())) {
      return false;
    }
    if (filterStatus !== "All" && String(row.StatusNameA || "") !== filterStatus) {
      return false;
    }
    if (filterCity !== "All" && String(row.ToCityName || "") !== filterCity) {
      return false;
    }
    if (filterFromDate || filterToDate) {
      const dateVal = row.PickupDate || row.DeliveryDate;
      if (dateVal) {
        const rowDate = new Date(dateVal);
        if (filterFromDate && rowDate < new Date(filterFromDate)) {
          return false;
        }
        if (filterToDate) {
          const toD = new Date(filterToDate);
          toD.setHours(23, 59, 59);
          if (rowDate > toD) {
            return false;
          }
        }
      }
    }
    if (globalSearch) {
      const searchStr = globalSearch.toLowerCase();
      const match =
        String(row.AWB || "").toLowerCase().includes(searchStr) ||
        String(row.ToConsigneeName || "").toLowerCase().includes(searchStr) ||
        String(row.ToPhone || "").toLowerCase().includes(searchStr) ||
        String(row.ToAddress || "").toLowerCase().includes(searchStr) ||
        String(row.ToCityName || "").toLowerCase().includes(searchStr) ||
        String(row.StatusNameA || "").toLowerCase().includes(searchStr);
      if (!match) return false;
    }
    return true;
  });

  const instance = axiosInstance();
  const categories = [
    { statusID: 0, name: "allShipments" },
    { statusID: 1, name: "delivered" },
    { statusID: 2, name: "processing" },
    { statusID: 3, name: "returned" },
    { statusID: -1, name: "paid" },
    { statusID: -2, name: "expected" },
  ];
  const statusID = categories.find(
    (category) =>
      category.name ===
      Object.entries(queryState).find((entry) => entry[1] === true)?.[0]
  )?.statusID;
  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  const toDate = new Date();
  toDate.setDate(toDate.getDate() + 1);
  toDate.setHours(toDate.getHours() + 3);

  const fetchShipments = async (statusID) => {
    if (!fetchingData) return;
    await delay(300);
    try {
      const data = await instance.post("/GetShipmentsPage", {
        mainStatusID: statusID,
        FromDate: "2020-04-20T13:23:30.141Z",
        ToDate: toDate.toISOString(),
        pageParam: {
          pageSize: 500,
          pageNumber: refetchKey,
        },
      });

      if (data.data.shipments.length == 0) {
        setFetchingData(false);
      }
      return data.data.shipments.map((shipment) => ({
        ...shipment,
        NetCOD: shipment.COD - shipment.ShipmentFees,
        runnerData: `
          ${shipment.RunnerName}  /
          ${shipment.RunnerMobile}
          `,
      }));
    } catch (error) {
      setFetchingData(false);
      if (error.response && error.response.status === 500) {
        navigate("/server-error");
      }
    }
  };

  const { refetch } = useQuery(
    ["reports", statusID, refetchKey],
    () => fetchShipments(statusID),
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      cacheTime: 1000,
      staleTime: 1000,
      onSuccess: (data) => {
        if (data && data.length > 0) {
          setRefetchKey((prev) => prev + 1);
          setMergedData((prevData) => [...prevData, ...data]);
        }
      },
    }
  );

  useEffect(() => {
    if (statusID !== undefined && statusID !== null) {
      refetch();
    }
  }, [statusID, refetch]);

  const buttons = {
    allShipments: false,
    delivered: false,
    returned: false,
    processing: false,
    paid: false,
    expected: false,
  };
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (searchParams.has("report")) {
      const status = searchParams.get("report");
      const statuses = [
        "processing",
        "returned",
        "paid",
        "expected",
        "allShipments",
        "delivered",
      ];
      if (statuses.includes(status)) {
        setQueryState({ ...buttons, [status]: true });
      }
    }
  }, [searchParams]);
  const changeUrl = (value) => {
    setSearchParams(`report=${value}`);
  };

  function changeActiveButton(e) {
    setFetchingData(true);
    queryClient.removeQueries("reports");
    setRefetchKey(1);
    let status = e.target.dataset.status;
    changeUrl(status);
    setQueryState({ ...buttons, [status]: true });
    setMergedData([]);
  }

  const handleStopButtonClick = () => {
    setFetchingData(false);
    setRefetchKey(1);
  };

  console.log(fetchingData);
  return (
    <selectedContext.Provider value={{ selected, setSelected }}>
      <Box className={styles.headerContainer}>
        <Header>
          <Title>{t("shipments_reports")}</Title>
        </Header>
        {fetchingData && (
          <StopButton onClick={handleStopButtonClick}>
            {t("stop_fetching_data")}
          </StopButton>
        )}
        {<NewPrintBtn print="shipments" data={selected} />}
      </Box>

      {/* Premium Filters Section */}
      <Box sx={{ margin: "10px", width: "100%" }}>
        <FilterContainer>
          <FilterGrid>
            {/* Global Search */}
            <FilterField>
              <FilterLabel>{isAr ? "بحث شامل في الجدول" : "Global Search"}</FilterLabel>
              <FilterInput
                type="text"
                placeholder={isAr ? "بحث في أي حقل..." : "Search anything..."}
                value={globalSearch}
                onChange={(e) => setGlobalSearch(e.target.value)}
              />
            </FilterField>

            {/* Serial Search */}
            <FilterField>
              <FilterLabel>{isAr ? "رقم الشحنة (سيريال)" : "Search Serial"}</FilterLabel>
              <FilterInput
                type="text"
                placeholder={isAr ? "أدخل رقم الشحنة..." : "Search serial..."}
                value={filterSerial}
                onChange={(e) => setFilterSerial(e.target.value)}
              />
            </FilterField>

            {/* Name Search */}
            <FilterField>
              <FilterLabel>{isAr ? "اسم المستلم" : "Search Name"}</FilterLabel>
              <FilterInput
                type="text"
                placeholder={isAr ? "أدخل اسم المستلم..." : "Search name..."}
                value={filterName}
                onChange={(e) => setFilterName(e.target.value)}
              />
            </FilterField>

            {/* Phone Search */}
            <FilterField>
              <FilterLabel>{isAr ? "رقم الهاتف" : "Search Phone"}</FilterLabel>
              <FilterInput
                type="text"
                placeholder={isAr ? "أدخل رقم الهاتف..." : "Search phone..."}
                value={filterPhone}
                onChange={(e) => setFilterPhone(e.target.value)}
              />
            </FilterField>

            {/* Status Dropdown */}
            <FilterField>
              <FilterLabel>{isAr ? "حالة الشحنة" : "Shipment Status"}</FilterLabel>
              <FilterSelect
                value={filterStatus}
                onChange={(e) => setFilterStatus(e.target.value)}
              >
                {uniqueStatuses.map((status) => (
                  <option key={status} value={status}>
                    {status === "All" ? (isAr ? "الكل" : "All") : status}
                  </option>
                ))}
              </FilterSelect>
            </FilterField>

            {/* City Dropdown */}
            <FilterField>
              <FilterLabel>{isAr ? "المدينة" : "City"}</FilterLabel>
              <FilterSelect
                value={filterCity}
                onChange={(e) => setFilterCity(e.target.value)}
              >
                {uniqueCities.map((city) => (
                  <option key={city} value={city}>
                    {city === "All" ? (isAr ? "الكل" : "All") : city}
                  </option>
                ))}
              </FilterSelect>
            </FilterField>

            {/* From Date */}
            <FilterField>
              <FilterLabel>{isAr ? "من تاريخ" : "From Date"}</FilterLabel>
              <FilterInput
                type="date"
                value={filterFromDate}
                onChange={(e) => setFilterFromDate(e.target.value)}
              />
            </FilterField>

            {/* To Date */}
            <FilterField>
              <FilterLabel>{isAr ? "إلى تاريخ" : "To Date"}</FilterLabel>
              <FilterInput
                type="date"
                value={filterToDate}
                onChange={(e) => setFilterToDate(e.target.value)}
              />
            </FilterField>
          </FilterGrid>

          {/* Reset Filters Option */}
          {(filterSerial || filterName || filterPhone || filterStatus !== "All" || filterCity !== "All" || filterFromDate || filterToDate || globalSearch) && (
            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
              <button
                onClick={() => {
                  setFilterSerial("");
                  setFilterName("");
                  setFilterPhone("");
                  setFilterStatus("All");
                  setFilterCity("All");
                  setFilterFromDate("");
                  setFilterToDate("");
                  setGlobalSearch("");
                }}
                style={{
                  padding: "8px 16px",
                  backgroundColor: "#fee2e2",
                  color: "#ef4444",
                  border: "none",
                  borderRadius: "6px",
                  fontSize: "13px",
                  fontWeight: 600,
                  cursor: "pointer",
                  transition: "background-color 0.2s",
                }}
              >
                {isAr ? "تصفية الفلاتر ✕" : "Clear Filters ✕"}
              </button>
            </Box>
          )}
        </FilterContainer>
      </Box>

      <Box sx={{ margin: "10px", width: "100%" }}>
        <ShipmentsReportsTable rows={filteredData} />
      </Box>
    </selectedContext.Provider>
  );
}
